import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {PasswordValidation} from "./password-validator";
import {PuntoVendita} from "../../../models/PuntoVendita";
import {PVenditaUtente} from "../../../models/PVenditaUtente";
import {ServerService} from "../../../services/server.service";
import {EsercizioUtente} from "../../../models/EsercizioUtente";
import _, {lowerFirst} from "lodash";
import {DialogService} from "../dialog/dialog.service";

@Component({
   selector: 'app-esercizio-user-form',
   templateUrl: './esercizio-user-form.component.html',
   styleUrls: ['./esercizio-user-form.component.scss']
})
export class EsercizioUserFormComponent implements OnInit, AfterViewInit {
   @Input() isNew:boolean = false
   @Input() vendorSlug:string = ''
   @Input() puntiVenditaEsercizio:PuntoVendita[] = []
   @Input() esercizioUtente:EsercizioUtente = new EsercizioUtente({})
   frmGrpEsUser: UntypedFormGroup = new UntypedFormGroup({});
   PVenditaUtente = PVenditaUtente

   constructor(private serverSrv:ServerService,
               private dialogSrv:DialogService
   ) {
      this.initForm()
   }

   ngOnInit(): void {
   }

   ngAfterViewInit() {
      if (this.puntiVenditaEsercizio.length > 0){
         for (const i in this.puntiVenditaEsercizio) {
            this.permessiArray.push(new UntypedFormGroup({
               pv_id: new UntypedFormControl(this.puntiVenditaEsercizio[i].data.id),
               nome_pv: new UntypedFormControl(this.puntiVenditaEsercizio[i].data.nome),
               ruolo: new UntypedFormControl('0'),
            }))
         }
      }

      if (this.esercizioUtente.ID){
         this.updateForm()
      }
   }

   get permessiArray(){
      return this.frmGrpEsUser.get('permessi') as UntypedFormArray
   }

   initForm(){
      this.frmGrpEsUser = new UntypedFormGroup({
         first_name: new UntypedFormControl(null, Validators.required),
         last_name: new UntypedFormControl(null, Validators.required),
         email: new UntypedFormControl(null, [Validators.required, Validators.email]),
         // username: new FormControl(null, Validators.required),
         ruolo_es: new UntypedFormControl('0'),
         permessi: new UntypedFormArray([
         ])
      }, {validators: PasswordValidation.MatchPassword})
   }

   updateForm(){
      console.log(this.esercizioUtente)
      this.frmGrpEsUser.patchValue(this.esercizioUtente.data.user)
      this.frmGrpEsUser.get('ruolo_es')?.patchValue(this.esercizioUtente.data.esercizio_role.toString())
      let puntivenditaUtenti = this.esercizioUtente.data.pvendita_utenti
      for (let i in puntivenditaUtenti){
         _.find(this.permessiArray.controls, (x:any) => {
            console.log(x)
            if(x.controls?.pv_id?.value === puntivenditaUtenti[i].p_vendita.id){
               console.log(puntivenditaUtenti[i].ruolo)
               console.log(puntivenditaUtenti[i].pvendita_role)
               if (puntivenditaUtenti[i].pvendita_role) x.controls.ruolo.patchValue(puntivenditaUtenti[i].pvendita_role.toString())
            }
         })
      }

      console.log(this.frmGrpEsUser)
   }

   async clickAggiungiPVUser() {
      return new Promise((resolve, reject) => {
            if (this.frmGrpEsUser.valid) {
               this.serverSrv.post(`/api/esercizi/${this.vendorSlug}/esercizi_utenti`, this.frmGrpEsUser.value, null).then(res => {
                  resolve(res)
               }).catch(err => {
                  reject(err)
               })
            }else {
               this.frmGrpEsUser.markAllAsTouched()
               reject('Form non valido')
               console.log("NON VALIDO")
            }
         }
      )
   }

   async clickModificaPVUser(){
      return new Promise((resolve, reject) => {
         if (this.frmGrpEsUser.valid){
            this.serverSrv.put(`/api/esercizi/${this.vendorSlug}/esercizi_utenti/${this.esercizioUtente.ID}`, this.frmGrpEsUser.value, null).then(res => {
               resolve(res)
            }).catch(err => {
               reject(err)
            })
         }else {
            this.frmGrpEsUser.markAllAsTouched()
            reject('Form non valido')
            console.log("NON VALIDO")
         }
      })
   }

   clickInvitaNuovamente() {
      return new Promise((resolve, reject) => {
         this.dialogSrv.showConfirm({title:"Invita nuovamente", msg:"Vuoi invitare nuovamente l\'utente?"}).then(() => {
            this.serverSrv.post(`/api/esercizi/${this.vendorSlug}/esercizi_utenti/${this.esercizioUtente.ID}/invita`, {}, null).then(res => {
               resolve(res)
            }).catch(err => {
               reject(err)
            })
         })
      })

   }

   clickInviaResetPassword(){
      return new Promise((resolve, reject) => {
         this.dialogSrv.showConfirm({title:"Reset password", msg:"Vuoi inviare la mail per il reset password?"}).then(() => {
            this.serverSrv.post(`/api/password_reset/`, {email:this.esercizioUtente.data.user.email}, null).then(res => {
               resolve(res)
            }).catch(err => {
               reject(err)
            })
         })
      })
   }

   clickEliminaUtente(){
      return new Promise((resolve, reject) => {
            this.dialogSrv.showConfirm({title:"Elimina Utente", msg:"Vuoi davvero eliminare l'utente?"}).then(() => {
               this.serverSrv.delete(`/api/esercizi/${this.vendorSlug}/esercizi_utenti/${this.esercizioUtente.ID}`, {}, null).then(res => {
                  resolve(res)
               }).catch(err => {
                  reject(err)
               })
            })
         }
      )}
}
